import {Button} from 'antd'
import {course_class_getAttendances_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {BiSolidEdit, BiTrash} from 'react-icons/bi'
import {BsPersonBoundingBox, BsThreeDots} from 'react-icons/bs'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {DateNameSortBy} from 'views/AppLocals/factory/createEntitySortBy'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import {renderCourseClassAttendance} from 'views/Workspace/Course/functions/renderCourseClassAttendance'
import {bindQueryParam} from '../../../functions/routerHelper'
import CourseClassContext from '../../CourseClassContext'
import {AiOutlineAudit} from "react-icons/ai";
import EmptyHolder from "../../../../../components/EmptyHolder";
import {LayoutContext} from "../../../../../components/layouts/Default/LayoutContext";
import {useRouteSearchParam} from "../../../../../envs/_current/history";
import {PiChartBarFill, PiUserListFill} from "react-icons/pi";
import {useCourseAttendances} from "../../functions/useCourseAttendances";
import {AttendanceActionTypes} from "../../index";
import {CourseClassStudentAttendanceStats, StudentAttendanceSessionList} from "../CourseClassAttendanceForm";
import classNames from "classnames"
import {CourseClassTabHeader, ViewRoleToggle} from "../components/CourseClassTabHeader"


const CourseClassAttendanceTab = ({
                                      filter_actions = {
                                          sortBy: 'sort-by',
                                          keyword: 'keyword',
                                          course_id: 'course_id',
                                          subject_id: 'subject-id',
                                      },
                                  }) => {
    const t = useTranslate()

    const {isSm} = useContext(LayoutContext)

    const {item} = useContext(CourseClassContext)
    // Route entity đã ẩn hẳn tab này với người không có can_edit (courseClassRouteEntities.js) -
    // tab CHỈ dành cho giảng viên/điều phối lớp. Toggle "Quản trị/Học viên" CHỈ hiện khi người dùng
    // giữ ĐỒNG THỜI 2 vai trò trong lớp này (vừa quản trị vừa là học viên - is_class_member, field
    // mới ở CourseClassTransformerBasic) - 1 vai trò thì ẩn toggle, mặc định đúng vai trò đó luôn.
    const can_edit = !!item?.edit || !!item?.available_actions?.can_checkin
    const is_class_member = !!item?.is_class_member
    const showRoleToggle = can_edit && is_class_member
    const [viewAsRole, setViewAsRole] = useState(can_edit ? 'admin' : 'student')
    const [activeTab, setActiveTab] = useState('0')

    const sortBy = useRouteSearchParam(filter_actions.sortBy)


    const course_class_id = getId(item)

    const owner_id = getId(item?.course)

    const owner_type = getType(item?.course)

    const subjects = useMemo(
        () => (item?.class_subjects ?? []).map((cs) => cs.subject).filter(Boolean),
        [item?.class_subjects]
    )

    const [activeSubjectId, setActiveSubjectId] = useState(() => getId(subjects[0]) || null)

    const {
        modal,
        refresh_token,
        handleAction = NullAsDefault,
    } = useCourseAttendances({course_class: item})

    const refreshKey = useMemo(
        () => [refresh_token, course_class_id, activeSubjectId].join(''),
        [refresh_token, course_class_id, activeSubjectId]
    )

    const renderContextMenu = useCallback(
        (item) =>
            can_edit ? createContextMenu(
                [
                    {
                        icon: <AiOutlineAudit size={14} className="text-green-600"/>,
                        label: 'attendances',
                        key: AttendanceActionTypes.DETAIL,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: AttendanceActionTypes.UPDATE,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: AttendanceActionTypes.DELETE,
                    },
                ].filter((e) => item), (key) => {
                    handleAction(key, item)
                },
                {
                    icon: (
                        <div
                            style={{width: 22, height: 22, borderRadius: 999}}
                            className="flex flex-center background hover:background-200 text-color-500 hover:text-color-100 cursor-pointer">
                            <BsThreeDots size={12}/>
                        </div>
                    ),
                }
            ) : undefined,
        [can_edit]
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            owner_id,
            owner_type,
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({subject_id: activeSubjectId})
            onSortChange(sortBy)
        },
        pagerInfo: {
            PaginationMeta: NullAsDefault,
            RenderEntity: React.Fragment,
            apiInfo: course_class_getAttendances_Api,
            query: bindQueryParam({id: course_class_id}),
            renderItem: renderCourseClassAttendance({
                renderContextMenu,
                handleAction,
            }),
            renderWrap: (child) => (
                <div className="flex flex-col divide-y divide-gray-200 list-item-workspace">
                    {child}
                </div>
            )
        },
        renderSearchBar: NullAsDefault,
        SortByWidget: DateNameSortBy,
        query_params: filter_actions,
        sortHeader: t('list of lesson'),
        withKey: createPagerKey(refreshKey),
        dependencies: [activeSubjectId],
        // AdvancedFilter (panel "Chọn môn học" nổi lên tự động) đã BỎ - trùng chức năng với hàng
        // chip lọc môn học ngay bên trên (activeSubjectId), lại còn tự bật lên (usePaginationHelper
        // auto-toggle khi filter có giá trị) gây rối mắt + không bấm chọn được item bên trong.
        // renderFilter = null: ExpandablePanel bọc filter_bar vẫn tự render khung rỗng dù
        // AdvancedFilter không có nội dung (isToggle vẫn true do auto-toggle) - tắt hẳn khung này.
        renderFilter: () => null,
    })

    const adminTabs = [
        {key: '0', icon: <PiUserListFill size={12}/>, label: t('attendance')},
        // Trước dùng chung key 'students' ("Học viên") - dễ nhầm với tab "Học viên" của lớp (danh
        // sách thành viên), trong khi đây là bảng THỐNG KÊ chuyên cần theo từng học viên.
        {key: '1', icon: <PiChartBarFill size={12}/>, label: t('attendance stats by student')},
    ]

    return (
        <div className="flex flex-col gap-3">
            {can_edit && (
                <div className="px-3 py-2 flex items-center justify-between gap-2 bg-indigo-50 border border-indigo-100 rounded-lg">
                    <div className="flex items-center gap-2 min-w-0">
                        <BsPersonBoundingBox size={14} className="text-indigo-500 flex-shrink-0"/>
                        <span className="text-xs text-indigo-700 leading-snug">
                            {t(viewAsRole === 'admin' ? 'this tab is for class admin only' : 'viewing attendance as a student')}
                        </span>
                    </div>
                    {showRoleToggle && (
                        <ViewRoleToggle role={viewAsRole} onChange={setViewAsRole}/>
                    )}
                </div>
            )}
            {viewAsRole === 'admin' && can_edit && (
                <CourseClassTabHeader
                    tabs={adminTabs}
                    activeKey={activeTab}
                    onTabChange={setActiveTab}
                    showTabs={!item?.is_class_leader}
                />
            )}

            {viewAsRole === 'admin' && can_edit ? (
                <>
                    {activeTab === '0' && (
                        <div className="w-full flex flex-col flex-1 gap-3">
                            {!!item?.is_class_leader ? (
                                <div className="flex flex-col py-1">
                                    <span className="font-semibold text-base text-gray-700 tracking-wide">
                                        {t('attendance behalf of the teacher')}
                                    </span>
                                    <div className="w-20 h-1 my-1 rounded-full bg-gray-400"/>
                                    <span className="text-xs text-color-300 tracking-wider">
                                        {t('attendance behalf of the teacher description')}
                                    </span>
                                </div>
                            ) : (
                                <div className="flex items-center justify-between gap-2 py-1">
                                    <div className="flex flex-col py-1">
                                        <span className="font-semibold text-base text-gray-700 tracking-wide">
                                            {t('attendance of students')}
                                        </span>
                                        <div className="w-20 h-1 my-1 rounded-full bg-gray-400"/>
                                        <span className="text-xs text-color-300 tracking-wider">{t('create attendance description')}</span>
                                    </div>
                                    <Button
                                        style={{padding: isSm ? "0 12px" : "0 18px"}}
                                        color="primary" variant="solid"
                                        className="rounded-lg no-border flex flex-center font-medium text-xs md:text-sm"
                                        onClick={() => handleAction(
                                            AttendanceActionTypes.CREATE,
                                            // Đã lọc theo môn học ở hàng chip bên dưới rồi thì điền
                                            // sẵn luôn vào form tạo mới - khỏi hỏi lại 2 lần cùng 1
                                            // việc (chip filter + dropdown môn học trong form).
                                            activeSubjectId ? {subject_id: activeSubjectId} : undefined
                                        )}>
                                        {t('create')}
                                    </Button>
                                </div>
                            )}
                            {subjects.length > 0 && (
                                <div className="flex gap-2 flex-wrap">
                                    {subjects.map((s) => (
                                        <button
                                            key={getId(s)}
                                            onClick={() => setActiveSubjectId(activeSubjectId === getId(s) ? null : getId(s))}
                                            style={{height: 30}}
                                            className={classNames(
                                                'px-3 text-xs font-semibold rounded-lg transition-all duration-300',
                                                activeSubjectId === getId(s)
                                                    ? 'bg-indigo-600 border-indigo-600 text-white'
                                                    : 'border border-color-200 hover:border-indigo-400 background text-color-300 hover:text-indigo-500'
                                            )}>
                                            {s?.title}
                                        </button>
                                    ))}
                                </div>
                            )}
                            {activeSubjectId
                                ? <div className="flex flex-col gap-2">{pager_widget}</div>
                                : <EmptyHolder title={t('please select a subject')}/>
                            }
                        </div>
                    )}
                    {activeTab === '1' && (
                        <div className="w-full flex flex-col flex-1">
                            <CourseClassStudentAttendanceStats courseClass={item}/>
                        </div>
                    )}
                </>
            ) : (
                <div className="w-full flex flex-col flex-1 gap-3 py-1">
                    <StudentAttendanceSessionList course_class_id={course_class_id} readOnly={true}/>
                </div>
            )}
            {modal}
        </div>
    )
}

export default CourseClassAttendanceTab
